@if (filtersForm) {
  <div [formGroup]="filtersForm">
    <mat-toolbar class="pt-2 lg:pb-0 justify-center mat-toolbar-multi-row px-0" style="background: transparent;">
      <div class="flex flex-col w-full">
        <div>
          @if (hasFilters) {
            <div class="flex flex-col lg:flex-row justify-between items-center">
              @if (searchFormControlData) {
                <div class="w-full flex flex-row">
                  <lib-form-text [formType]="'search-input'" class="search-col" [formControlName]="searchFormControlData.formControlName"
                  [label]="searchFormControlData.name" [placeholder]="'Search'" [suffix]="'search'"></lib-form-text>
                  <a class="filter-button flex cursor-pointer ml-6 items-center " (click)="closeFilter()">
                    <lib-icon [icon]="'filter'" class="icon"></lib-icon>
                    <span class="pl-2">{{openFilters ? 'Hide' : 'Show' }} Filters</span>
                  </a>
                </div>
              }
              <div class="flex flex-col w-full lg:w-auto lg:flex-row gap-4">
                @for (filter of visibleFormControlData; track filter; let i = $index) {
                  <div>
                    @if (filter.type === 'date') {
                      <lib-custom-date-picker [formControlName]="filter.formControlName" [label]="filter.name"></lib-custom-date-picker>
                    }
                  </div>
                }
                <a class="filter-button flex cursor-pointer ml-6 items-center self-center" style="min-height: 28px; max-height: 36px !important;" (click)="clearFilters()">
                  <lib-icon [icon]="'close'" class="icon"></lib-icon>
                  Clear Filters
                </a>
              </div>
            </div>
          }
        </div>
        @if (openFilters) {
          <div class="flex items-center w-full flex-col lg:flex-row px-2 mt-3 filter-row">
            <div class="w-full flex flex-col lg:flex-row">
              @for (filter of hiddenFormControlData; track filter) {
                <div [ngStyle]="{ 'width.%': !smallScreen ? filter.type === 'checkBox' ? null :  100 : 100 }"
                  [ngClass]=" filter.type === 'checkBox' ? 'flex items-center p-2' : 'flex flex-col p-2'"
                  >
                  @if (filter.type === 'dropdown') {
                    <lib-form-dropdown class="filter" [formControlName]="filter.formControlName" [label]="filter.name"
                      [options]="isArray(filter.lookup) ? filter.lookup : isSignal(filter.lookup) ? filter.lookup() : (filter.lookup | async)"
                      [firstOption]="!filter.hideAllInDropdown ? {id: '', name: 'All'} : undefined">
                    </lib-form-dropdown>
                  }
                  @if (filter.type === 'checkBox') {
                    <mat-checkbox class="filter" [formControlName]="filter.formControlName">{{filter.name}}</mat-checkbox>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    </mat-toolbar>
    @if (smallScreen) {
      @if (mobileData().length > 0) {
        @for (row of mobileData(); track row) {
          <div class="mtable mt-5">
            @if (gridOptions()?.columns?.length ?? 0 > 0) {
              <div class="mtable__body">
                @for (column of gridOptions()?.columns; track column) {
                  <div class="mtable__flex">
                    <div class="mtable__left">{{column.header}}</div>
                    @if (!column.actionColumnitems && !column.displayPipe) {
                      <div class="mtable__right"
                        [ngClass]="column.conditionalClass && column.conditionalClass.column ? column.conditionalClass.calculateClass(row[column.conditionalClass.column]) : ''"
                        >
                        {{ !row[column.controlName] ? '-' : row[column.controlName]}}
                      </div>
                    }
                    <!-- <div class="mtable__right" [ngClass]="column.conditionalClass && column.conditionalClass.column ? column.conditionalClass.calculateClass(row[column.conditionalClass.column]) : ''"
                    *ngIf="!column.actionColumnitems && column.displayPipe ==='truncate'">
                    {{ !row[column.controlName] ? '-' : (row[column.controlName] | truncateText: 25) }}
                  </div> -->
                  @if (!column.actionColumnitems && column.displayPipe ==='date') {
                    <div class="mtable__right"
                      [ngClass]="column.conditionalClass && column.conditionalClass.column ? column.conditionalClass.calculateClass(row[column.conditionalClass.column]) : ''"
                      >
                      {{ !row[column.controlName] ? '-' : (utcToLocalDate(row[column.controlName]) | date : 'MM/dd/yyyy') }}
                    </div>
                  }
                  @if (!column.actionColumnitems && column.displayPipe ==='currency') {
                    <div class="mtable__right"
                      [ngClass]="column.conditionalClass && column.conditionalClass.column ? column.conditionalClass.calculateClass(row[column.conditionalClass.column]) : ''"
                      >
                      {{ !row[column.controlName] ? '-' : (row[column.controlName] | currency) }}
                    </div>
                  }
                  @if (!column.actionColumnitems && column.displayPipe ==='space') {
                    <div class="mtable__right"
                      [ngClass]="column.conditionalClass && column.conditionalClass.column ? column.conditionalClass.calculateClass(row[column.conditionalClass.column]) : ''"
                      >
                      {{ !row[column.controlName] ? '-' : camelCaseToTitleCase(row[column.controlName]) }}
                    </div>
                  }
                  @if (!column.actionColumnitems && column.displayPipe ==='joinList') {
                    <div class="mtable__right"
                      [ngClass]="column.conditionalClass && column.conditionalClass.column ? column.conditionalClass.calculateClass(row[column.conditionalClass.column]) : ''"
                      >
                      {{ (!row[column.controlName] || row[column.controlName].length === 0) ? '-' :
                      row[column.controlName].join(', ') }}
                    </div>
                  }
                  @if (column.actionColumnitems) {
                    <div class="mtable__right"
                      [ngClass]="column.conditionalClass && column.conditionalClass.column ? column.conditionalClass.calculateClass(row[column.conditionalClass.column]) : ''"
                      [ngClass]="column.actionColumnitems.length > 1 ? 'gap-2' : ''">
                      <div class="items-center">
                        @for(action of column.actionColumnitems; track $index) {
                          @if (action.type === 'dropdown') {
                            <lib-button [cssType]="'btn-icon-dropdown'"
                    [hidden]="!action.hideOnColumnValue ? false :
                    action.hideOnColumnValue.values.includes(row[action.hideOnColumnValue.column])"
                              [disabled]="!action.disableOnColumnValue ? false : action.disableOnColumnValue.values.includes(row[action.disableOnColumnValue.column])"
                              [menuItems]="dropdownMenuItems(row, action.dropdownItems?.() ?? [])"
                              [icon]="action.conditionalDisplay.calculateDisplay(row[action.conditionalDisplay.column])"
                              [gridContainerSelector]="'.grid-table'"
                              [forceDropUp]="matDataSource().data.length === 1"
                            ></lib-button>
                          }
                          @else {
                          <lib-button [cssType]="'btn-icon'"
                            [text]="action.type === 'text' ? action.conditionalDisplay.calculateDisplay(row[action.conditionalDisplay.column]) : ''"
                            [icon]="action.type === 'icon' ? action.conditionalDisplay.calculateDisplay(row[action.conditionalDisplay.column]) : ''"
                  [hidden]="!action.hideOnColumnValue ? false :
                  action.hideOnColumnValue.values.includes(row[action.hideOnColumnValue.column])"
                            [buttonType]="'button'"
                            [disabled]="!action.disableOnColumnValue ? false : action.disableOnColumnValue.values.includes(row[action.disableOnColumnValue.column])"
                          (click)="actionButton(row, action.buttonAction)"></lib-button>
                        }
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  }
  @if (!gridOptions()?.hidepagination) {
    <div class="flex my-4 w-full px-2 justify-end items-center custom-pagination"
      >
      <div class="flex items-center mat-paginator-page-size">
        <div class="custom-pagination-label">Items per page:</div>
        <div [formGroup]="paginationForm">
          <mat-form-field class="mat-paginator-page-size-select">
            <mat-select formControlName="pageSize">
              @for (pageSize of pageSizeOptions; track pageSize) {
                <mat-option [value]="pageSize">
                  {{ pageSize }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="flex custom-pagination-buttons">
        <div class="">
          <span>Items {{ itemsFrom() }}-{{ itemsTo() }} of {{ totalNumberOfItems() }}</span>
        </div>
        <button class="cursor-pointer border-none background-none" (click)="paginationLeft()">
          <lib-icon [icon]="'chevron-left'" class="icon"></lib-icon>
        </button>
        <div>
          <span>{{ currentPageNumber() }}</span>
          <span>of</span>
          <span>{{ totalNumberOfPages() }}</span>
        </div>
        <button class="cursor-pointer border-none background-none" (click)="paginationRight()">
          <lib-icon [icon]="'chevron-right'" class="icon"></lib-icon>
        </button>
      </div>
    </div>
  }
  @if (!gridOptions()?.data()?.length) {
    <div class="mt-5 px-4">No data</div>
  }
} @else {
  <mat-card class="grid-table p-0 sm:px-4  pb-0">
    <mat-card-content class="wrap-anywhere overflow-x-auto" style="overflow: visible;">
      <table mat-table (matSortChange)="sortData($event)"
        [dataSource]="gridOptions()?.frontEndPagination ? (matDataSource()) : (matDataSource().data || [])"
        class="w-full table-responsive" matSort>
        @for (column of gridOptions()?.columns; track column) {
          <ng-container [matColumnDef]="column.controlName">
            <!-- <ng-template [ngIf]="!column.actionColumnitems && column.displayPipe ==='truncateWithCount'">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="!gridOptions()?.hideSort && !column.hideColumnSort ? false : true" class="font-bold">{{column.header}}</th>
            <td mat-cell *matCellDef="let row" [ngClass]="column.conditionalClass && column.conditionalClass.column ? column.conditionalClass.calculateClass(row[column.conditionalClass.column]) : ''">
              {{ !row[column.controlName] ? '-' : (row[column.controlName] | truncateWithCount: 20) }}
            </td>
          </ng-template> -->
          @if (!column.actionColumnitems && !column.displayPipe) {
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [disabled]="!gridOptions()?.hideSort && !column.hideColumnSort ? false : true" class="font-bold">
            {{column.header}}</th>
            <td mat-cell *matCellDef="let row"
              [ngClass]="column.conditionalClass && column.conditionalClass.column ? column.conditionalClass.calculateClass(row[column.conditionalClass.column]) : ''"
              [ngStyle]="{'minWidth': column?.minWidth ?? '', 'max-width': column?.maxWidth ?? ''}">
              {{ !row[column.controlName] ? '-' : row[column.controlName] }}
            </td>
          }
          @if (!column.actionColumnitems && column.displayPipe ==='truncate') {
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [disabled]="!gridOptions()?.hideSort && !column.hideColumnSort ? false : true" #truncateCol
            class="font-bold truncate-col">{{column.header}}</th>
            <td mat-cell *matCellDef="let row" class="truncate-col" [ngStyle]="{'width':  truncateSize }"
              [ngClass]="column.conditionalClass && column.conditionalClass.column ? column.conditionalClass.calculateClass(row[column.conditionalClass.column]) : ''"
              [ngStyle]="{'minWidth': column?.minWidth ?? '', 'max-width': column?.maxWidth ?? ''}">
              <div class="text">
                {{ !row[column.controlName] ? '-' : (row[column.controlName]) }}
              </div>
            </td>
          }
          @if (!column.actionColumnitems && column.displayPipe ==='space') {
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [disabled]="!gridOptions()?.hideSort && !column.hideColumnSort ? false : true" class="font-bold">
            {{column.header}}</th>
            <td mat-cell *matCellDef="let row"
              [ngClass]="column.conditionalClass && column.conditionalClass.column ? column.conditionalClass.calculateClass(row[column.conditionalClass.column]) : ''"
              [ngStyle]="{'minWidth': column?.minWidth ?? '', 'max-width': column?.maxWidth ?? ''}">
              {{ !row[column.controlName] ? '-' : camelCaseToTitleCase(row[column.controlName]) }}
            </td>
          }
          @if (!column.actionColumnitems && column.displayPipe === 'date') {
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [disabled]="!gridOptions()?.hideSort && !column.hideColumnSort ? false : true" class="font-bold">
            {{column.header}}</th>
            <td mat-cell *matCellDef="let row"
              [ngClass]="column.conditionalClass && column.conditionalClass.column ? column.conditionalClass.calculateClass(row[column.conditionalClass.column]) : ''"
              [ngStyle]="{'minWidth': column?.minWidth ?? '', 'max-width': column?.maxWidth ?? ''}">
              {{ !row[column.controlName] ? '-' : (row[column.controlName] | date : 'MM/dd/yyyy') }}
            </td>
          }
          @if (!column.actionColumnitems && column.displayPipe === 'currency') {
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [disabled]="!gridOptions()?.hideSort && !column.hideColumnSort ? false : true" class="font-bold">
            {{column.header}}</th>
            <td mat-cell *matCellDef="let row"
              [ngClass]="column.conditionalClass && column.conditionalClass.column ? column.conditionalClass.calculateClass(row[column.conditionalClass.column]) : ''"
              [ngStyle]="{'minWidth': column?.minWidth ?? '', 'max-width': column?.maxWidth ?? ''}">
              {{ !row[column.controlName] ? '-' : (row[column.controlName] | currency) }}
            </td>
          }
          @if (!column.actionColumnitems && column.displayPipe === 'joinList') {
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [disabled]="!gridOptions()?.hideSort && !column.hideColumnSort ? false : true" class="font-bold">
            {{column.header}}</th>
            <td mat-cell *matCellDef="let row"
              [ngClass]="column.conditionalClass && column.conditionalClass.column ? column.conditionalClass.calculateClass(row[column.conditionalClass.column]) : ''"
              [ngStyle]="{'minWidth': column?.minWidth ?? '', 'max-width': column?.maxWidth ?? ''}">
              {{ (!row[column.controlName] || row[column.controlName].length === 0) ? '-' :
              row[column.controlName].join(', ') }}
            </td>
          }
          @if (column.actionColumnitems) {
            <th mat-header-cell *matHeaderCellDef class="font-bold text-center">{{column.header}}</th>
            <td mat-cell *matCellDef="let row; let rowIndex = index" [ngClass]="column.actionColumnitems.length > 1 ? 'gap-2' : ''"
              [ngStyle]="{'minWidth': column?.minWidth ?? '', 'max-width': column?.maxWidth ?? ''}">
              <div class="text-center relative">
                @for(action of column.actionColumnitems; track $index) {
                  @if (action.type === 'dropdown') {
                    <lib-button [cssType]="'btn-icon-dropdown'"
                        [hidden]="!action.hideOnColumnValue ? false :
                        action.hideOnColumnValue.values.includes(row[action.hideOnColumnValue.column])"
                      [disabled]="!action.disableOnColumnValue ? false : action.disableOnColumnValue.values.includes(row[action.disableOnColumnValue.column])"
                      [menuItems]="dropdownMenuItems(row, action.dropdownItems?.() ?? [])"
                      [icon]="action.conditionalDisplay.calculateDisplay(row[action.conditionalDisplay.column])"
                      [gridContainerSelector]="'.grid-table'"
                      [forceDropUp]="matDataSource().data.length === 1"
                    ></lib-button>
                  }
                  @else {
                  <lib-button [cssType]="'btn-icon'"
                    [text]="action.type === 'text' ? action.conditionalDisplay.calculateDisplay(row[action.conditionalDisplay.column]) : ''"
                    [icon]="action.type === 'icon' ? action.conditionalDisplay.calculateDisplay(row[action.conditionalDisplay.column]) : ''"
                      [hidden]="!action.hideOnColumnValue ? false :
                      action.hideOnColumnValue.values.includes(row[action.hideOnColumnValue.column])"
                    [buttonType]="'button'"
                    [disabled]="!action.disableOnColumnValue ? false : action.disableOnColumnValue.values.includes(row[action.disableOnColumnValue.column])"
                  (click)="actionButton(row, action.buttonAction)"></lib-button>
                }
              }
            </div>
          </td>
        }
      </ng-container>
    }
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" class="cursor-pointer hover:bg-lightgrey"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">No data</td>
    </tr>
  </table>
  <div class="flex flex-col sm:flex-row w-full pagination-container">
    @if (!gridOptions()?.hidepagination) {
      <div class="flex w-full justify-center items-center custom-pagination p-0 gap-1"
        >
        <div class="flex items-center mat-paginator-page-size">
          <div class="custom-pagination-label">Items per page:</div>
          <div [formGroup]="paginationForm">
            <mat-form-field class="mat-paginator-page-size-select">
              <mat-select formControlName="pageSize" class="mat-pagination-custom">
                @for (pageSize of pageSizeOptions; track pageSize) {
                  <mat-option [value]="pageSize"
                    class="custom-pagination-option">
                    {{ pageSize }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="flex custom-pagination-buttons">
          <div class="">
            <span>Items {{ itemsFrom() }}-{{ itemsTo() }} of {{ totalNumberOfItems() }}</span>
          </div>
          <button class="cursor-pointer border-none background-none" (click)="paginationLeft()">
            <lib-icon [icon]="'chevron-left'" class="icon"></lib-icon>
          </button>
          <div>
            <span>{{ currentPageNumber() }}</span>
            <span>of</span>
            <span>{{ totalNumberOfPages() }}</span>
          </div>
          <button class="cursor-pointer border-none background-none" (click)="paginationRight()">
            <lib-icon [icon]="'chevron-right'" class="icon"></lib-icon>
          </button>
        </div>
      </div>
    }
  </div>
</mat-card-content>
</mat-card>
}
</div>
}
@if (gridOptions()?.frontEndPagination) {
  <mat-paginator style="display: none;" [length]="totalNumberOfItems()"
    [pageSize]="itemsPerPage()" [pageSizeOptions]="pageSizeOptions" aria-label="Select page" [disabled]="true"
    class="hidden">
  </mat-paginator>
}